$(function(){
    function mobileDropdownOff() {
        var windowSize = $(window).width();

        if (windowSize > 767) {
            jQuery('.noticebar').find('.disabled').removeClass('disabled').addClass('enabled');
        } else if (windowSize <= 768) {
            jQuery('.noticebar').find('.enabled').removeClass('enabled').addClass('disabled');
        }
    }

    mobileDropdownOff();
    $(window).resize(mobileDropdownOff);

    $('[data-toggle="tooltip"]').tooltip();
});

$(function() {
    $(document).on('click', '.dropdown-menu', function (e) {
        e.stopPropagation();
    });
});

$(function(){
    var initBackToTop = function () {
        var backToTop = jQuery('<a>', { id: 'back-to-top', href: '#top' }),
            icon = jQuery('<i>', { 'class': 'glyphicon glyphicon-chevron-up' })

        backToTop.appendTo ('body')
        icon.appendTo (backToTop)

        backToTop.hide ()

        jQuery(window).scroll (function () {
            if (jQuery(this).scrollTop () > 250) {
                backToTop.fadeIn ()
            } else {
                backToTop.fadeOut ()
            }
        })

        backToTop.click (function (e) {
            e.preventDefault ()

            jQuery('body, html').animate({
                scrollTop: 0
            }, 600)
        })
    }
    initBackToTop();
});

$(function(){
    $('.bootstrap-tagsinput input.tt-input').on('keydown', preventConfirmKeys);

    function preventConfirmKeys(event){
        var confirmkeys = [13, 44];

        $.each(confirmkeys, function(index, confirmkey){
            if(event.which == confirmkey) {
                $(this).parents('.bootstrap-tagsinput').next('input').tagsinput('add', $(this).val());
                $(this).val('');
                event.preventDefault();
            }
        }.bind(this));
    }
});

$(function(){
    $('.bootstrap-tagsinput input.tt-input').on('keydown', preventConfirmKeys);

    function preventConfirmKeys(event){

        var confirmkeys = [13, 44];

        $.each(confirmkeys, function(index, confirmkey){
            if(event.which == confirmkey) {
                $(this).parents('.bootstrap-tagsinput').next('input').tagsinput('add', $(this).val());
                $(this).val('');
                event.preventDefault();
            }
        }.bind(this));
    }
});

$(function(){
    // $('.datepicker').datepicker({
    //     format: 'dd-mm-yyyy',
    //     orientation: 'bottom auto',
    //     weekStart: 1
    // });
});
